module.exports = __webpack_public_path__ + "static/media/programs_card_bg.757a0d84.jpg";